import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '機能別ログ',
  
  // model
  logModel: [],
  serviceModel: [],
  functionMastaModel: [],
  serviceFunctionModel: [],
  // 202305 機能選択に「見守り未回答通知機能」を追加 ST
  serviceFunctionDetailModel: {},
  noReplyEndDate: null,
  // 202305 機能選択に「見守り未回答通知機能」を追加 ED

  // model : サービス運用者の場合のみ
  serviceInfoModel: {},
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = []
      const methods = []
      const parameters = []

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push({})

      // サービス運用者の場合
      } else {
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            if (isAdmin) {
              commit('setServiceModel', res[0].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            } else {
              commit('setServiceInfoModel', res[0].data.serviceBasicInfo)
              console.log('serviceInfoModel', state.serviceInfoModel)
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * サービス機能一覧を取得
   */
  loadServiceFunctionList ({commit}, {serviceFunctionParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionListGet'],
        [serviceFunctionParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceFunctionModel', res[0].data.serviceFunctions)
            console.log('serviceFunctionModel', state.serviceFunctionModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  // 202305 機能選択に「見守り未回答通知機能」を追加 ST
  /**
   * サービス機能詳細設定情報取得
   */
  loadServiceFunctionDetail ({commit}, {serviceFunctionDetailParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
          ['serviceFunction'],
          ['v1ServiceFunctionDetailGet'],
          [serviceFunctionDetailParams])
          .then(res => {
            let status = Utility.parseResponse(res)
            if (status.result) {
              commit('setServiceFunctionDetailModel', res[0].data)
              console.log('serviceFunctionDetailModel', state.serviceFunctionDetailModel)
              resolve()
            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
    })
  },
  /**
   * 機能別ログ一覧を読出し
   */
  loadLogList ({commit}, {logParams}) {
    return new Promise((resolve, reject) => {
      let methods = []
      if (logParams.filters.functionMstUuid === Constants.Mst.FunctionDeliveryType.followNoReply)
        methods.push('v1LogNoReplyResponseGet')
      else
        methods.push('v1LogFunctionalGet')
      ApiManager.request(
        ['log'],
          methods,
        [logParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            if (logParams.filters.functionMstUuid === Constants.Mst.FunctionDeliveryType.followNoReply) {
              commit('setLogModel', res[0].data.noReplyLocationsInfo)
              commit('setNoReplyEndDateModel', res[0].data.noReplyEndDate)
            } else {
              commit('setLogModel', res[0].data.functionLogs)
            }
            console.log('logModel', state.logModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
  // 202305 機能選択に「見守り未回答通知機能」を追加 ED
}

const mutations = {
  // model
  setLogModel (state, data) {
    // data.sort(Utility.sortByKey('answeredAt', false))
    Vue.set(state, 'logModel', data)
  },
  setServiceModel (state, data) {
    Vue.set(state, 'serviceModel', data)
  },
  setFunctionModel (state, data) {
    Vue.set(state, 'functionMastaModel', data)
  },
  setServiceFunctionModel (state, data) {
    const items = data.filter(item => item.functionLogOutputFlg)
    Vue.set(state, 'serviceFunctionModel', items)
  },
  // 202305 機能選択に「見守り未回答通知機能」を追加 ST
  setNoReplyEndDateModel(state, data) {
    Vue.set(state, 'noReplyEndDate', '（' + data + '現在）')
  },
  setServiceFunctionDetailModel(state, data) {
    Vue.set(state, 'serviceFunctionDetailModel', data.followSetting != null ? data.followSetting.isNoReplyNotificationEnabled : null)
  },
  // 202305 機能選択に「見守り未回答通知機能」を追加 ED
  setServiceInfoModel (state, data) {
    Vue.set(state, 'serviceInfoModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
